module.exports = __webpack_public_path__ + "img/IMG_9934-43_P_L_Foamcore.c0174c23.jpg";